import { useAuthStore } from '@/store/auth'
import { createVisitCollector, createVisitNavigationCollector } from '../common/visit-pages.mjs'

export default defineNuxtPlugin(nuxtApp => {
  const auth = useAuthStore(), router = nuxtApp.$router
  const collect = createVisitCollector({ client: auth.client, isLoggedIn: () => auth.isLoggedIn })
  let mounted = false, resolveReady
  const ready = new Promise(resolve => { resolveReady = resolve })
  const navigation = createVisitNavigationCollector({ collect, currentRoute: () => router.currentRoute.value, ready })
  router.afterEach((to, from, failure) => navigation.navigate(to, from, failure, mounted))
  nuxtApp.hook('app:mounted', async () => {
    // 공개 화면의 기존 세션 복원과 같은 client의 단일 refresh를 공유한다.
    if (!auth.isLoggedIn && router.currentRoute.value.path !== '/password-reset') {
      try { await auth.client.refresh() } catch { /* 비회원 또는 통신 실패도 공개 화면을 계속 제공한다. */ }
    }
    mounted = true
    resolveReady()
    navigation.automatic(router.currentRoute.value)
  })
  // 공개 원문/본인 입과/학습 세션을 확인한 화면이 호출한다. 폴링·포커스 재조회는 같은 방문으로 중복 제거한다.
  return { provide: { collectVisit: navigation.record } }
})
